document.addEventListener('DOMContentLoaded', () => {
  const faqItems = document.querySelectorAll('.da-faq-item');

  faqItems.forEach((item, index) => {
    const header = item.querySelector('.da-faq-header');
    const content = item.querySelector('.da-faq-content');

    // Handle initial state if open by default
    if (item.classList.contains('active')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    header.addEventListener('click', () => {
      // Toggle active class
      const isActive = item.classList.contains('active');
      
      // Close other items (optional - user didn't ask, but common)
      // faqItems.forEach(otherItem => {
      //   if (otherItem !== item && otherItem.classList.contains('active')) {
      //     otherItem.classList.remove('active');
      //     otherItem.querySelector('.da-faq-content').style.maxHeight = null;
      //   }
      // });

      // Toggle current
      if (isActive) {
        item.classList.remove('active');
        content.style.maxHeight = null;
      } else {
        item.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});
